import { render } from "./GongYingShangKu.vue?vue&type=template&id=704f3a39"
import script from "./GongYingShangKu.vue?vue&type=script&lang=js"
export * from "./GongYingShangKu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__